import { procurementAPI } from "../../axios";

export const actions = {
    GetAllClientType(context, data){
        return procurementAPI.get(`ClientType/All`);
    },
    GetSingleClientType(context, data){
        return procurementAPI.get(`ClientType/${data}`);
    },
    UpdateClientType(context, data){
        return procurementAPI.put(`ClientType/Update/${data.id}`, data);
    },
    DeleteClientType(context, data){
        return procurementAPI.delete(`ClientType/Remove/${data}`);
    },
    CreateClientType(context, data){
        return procurementAPI.post(`ClientType/Create`, data);
    },
}